import { render } from "./WeddingInvitationForm.vue?vue&type=template&id=507e197e&scoped=true"
import script from "./WeddingInvitationForm.vue?vue&type=script&lang=js"
export * from "./WeddingInvitationForm.vue?vue&type=script&lang=js"

import "./WeddingInvitationForm.vue?vue&type=style&index=0&id=507e197e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507e197e"]])

export default __exports__